import axios from 'axios'
import TokenService from '../helpers/token'

const posApiUrl = process.env.VUE_APP_VH_POS_API

export default {
  /**
   * 
   * @param {number} params.user_id - ID của người dùng, mặc định lấy theo user đang đăng nhập, nếu không có thì không cần truyền
   * @param {number} params.is_read - 1: Đã đọc, 0: Chưa đọc, mặc định là 0
   * @param {number} params.is_archived - 1: Đã xóa, 0: Chưa xóa, mặc định là 0
   * @param {number} params.id - next page id
   * @param {boolean} params.backward - true: Lấy trang trước, false: Lấy trang sau, mặc định là false
   * @param {number} params.limit - Số lượng thông báo trên mỗi trang, mặc định là 20
   * @returns 
   */
  async list(params) {
    const response = await axios.get(`${posApiUrl}/notifications`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  /**
   * body: {
   *   userId: number, // ID của người dùng, mặc định lấy theo user đang đăng nhập, nếu không có thì không cần truyền
   *   title: string, // Tiêu đề của thông báo, bắt buộc
   *   message: string, // Nội dung của thông báo, bắt buộc
   *   type: string, // Loại thông báo, bắt buộc
   *   data: object, // Dữ liệu của thông báo, không bắt buộc
   * }
   * @returns {Promise<Object>} - Promise với dữ liệu thông báo
   */
  async create(body) {
    const response = await axios.post(`${posApiUrl}/notifications`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  /**
   * body: {
   *   ids: [], // ID của thông báo, bắt buộc
   * }
   * @returns {Promise<Object>} - Promise với dữ liệu response
   */
  async markAsRead(data) {
    const response = await axios.put(`${posApiUrl}/notifications/mark-read`,data, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  /**
   * 
   * @param {string} id - ID của thông báo, bắt buộc
   * @returns {Promise<Object>} - Promise với dữ liệu response
   */
  async delete(id) {
    const response = await axios.delete(`${posApiUrl}/notifications/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  /**
   * 
   * @returns {Promise<Object>} - Promise với dữ liệu response
   */
  async deleteAll() {
    const response = await axios.delete(`${posApiUrl}/notifications`, {
      headers: TokenService.getHeader(),
    })
    return response
  }
}

